<<template>  
  <prop-panel @close="close">
    <p slot="header">{{rs["takePhoto"]}}</p>
    <div style='width:560px;height:420px; left:0;top:0'>
      <img ref="uImg" id="uImg" :src="imgUrl" style='width:560px;height:420px; left:20px;top:10px; position: absolute; z-index=1;' />
      <div v-show="showPhoto" style="width:560px;height:420px; left:20px;top:10px; background-color: #555;position: absolute; z-index=2;opacity: 0.5;-moz-opacity:0.5;"></div>
      <div style="width: 304px; height: 404px; top: 18px; left: 148px; border: 2px solid red; background: transparent;position: absolute; z-index=3;">
        <img ref="photo" v-show="showPhoto" :src="photo" style="width: 300px; height: 400px;">
      </div>
    </div>
    <canvas id="canvas" ref="canvas" width="300" height="400" style='width:300px;height:400px;display:none;'></canvas>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="takePhoto" :disabled="showPhoto==1" type="button" class="btn btn-primary">{{rs["takePhoto"]}}</button>
      <button @click.stop="retakePhoto" :disabled="showPhoto==0"  type="button" class="btn btn-primary">{{rs["retakePhoto"]}}</button>
      <button @click.stop="submit" :disabled="showPhoto==0"  type="button" class="btn btn-primary">{{rs["submit"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created: function() {  
    this.fillDate=this.$dateNow(-1)
    //alert(canvas)
    //const canvas = document.getElementById("canvas")
    //const video=canvas.getContext("2d")
    /*if(navigator.webkitGetUserMedia){
      navigator.webkitGetUserMedia({"video":true},function(stream){  
              video.src=window.webkitURL.createObjectURL(stream)
              video.play()
          },function(){  
          console.log("sth srong")
      })
    }
    else if(navigator.getUserMedia){  
        navigator.getUserMedia({"video":true},function(stream){
            video.src=stream
            video.play()
        },function(){
          console.log("sth srong")
      })
    }*/
  },
  props:["detail", "img", "rs", "url"],
  data(){
    return {
      ws: null,
      imgUrl:"",
      fillDate:null,
      fillDate: "",
      fillType: 1,
      fillTarget: 3,
      gnNo: null,
      fcList:[],
      gnList:[],
      bc:null,
      fillTime: "",
      dept: null,
      photo:"",
      showPhoto: 0,
      uimg:null
    }
  },
  methods:{
    openWS(){
      if (!this.ws){
        alert("open")
        const wsImpl = window.WebSocket || window.MozWebSocket
        this.ws = new wsImpl('ws://localhost:9527/')
        const uimg = this.$refs.uImg
        this.ws.onmessage = (ev)=>{
          uimg.src = ev.data
        }
        this.ws.onopen = ()=> {
          this.ws.send("getImage")
        }
        this.ws.onclose = ()=>{
          this.ws = null
          console.log("closeImg")
        }
        this.ws.onerror = ()=>{
          this.$alert("服务连接失败，请检查服务是否已打开！")
        }
      }
    },
    close: function() {
      //if (this.ws) this.ws.send("closeImage")
      //this.$refs.video.pause()
      
      this.$emit("close");
    },
    takePhoto(){
      const vdo = this.$refs.uImg //this.$refs.video
      const canvas = document.getElementById("canvas")
      const ctx = canvas.getContext("2d");
      ctx.drawImage(vdo, 148, 11, 343, 457, 0, 0, 300, 400);
      this.photo = canvas.toDataURL("image/png");
      this.showPhoto = 1      
    },
    retakePhoto(){
      this.photo = ""
      this.showPhoto = 0
    },
    submit(){
      this.img.src = this.photo
      this.detail.bp = this.photo
      this.detail.photo = this.photo
      //this.$refs.video.pause()
      if (this.ws) this.ws.send("closeImage")
      this.$emit("close");
    }
  }
}
</script>
